/**
* Sliders Module
*
* Manage sliders property shared across bubbleflow sliders
*/
angular
.module('gc.sliders', [])
.service('SliderService', [
'$rootScope',
'$document',
'$window',
'$timeout',
'$interval',
function($rootScope, $document, $window, $timeout, $interval) {
  'use strict';
  var service = this;

  var slider;

  this.avatarWidth = 0;
  this.maxVisibleAvatar = 1;
  this.computeNbVisibleAvatar = computeNbVisibleAvatar;

  this.init = function() {
    $rootScope.$on('gc:ready', function() {
      angular.element($window).on('resize', onResize);
      $timeout(function() {
        computeNbVisibleAvatar();
      }, 0);
      $interval(function() {
        computeNbVisibleAvatar();
      }, 1000);
    });
  };

  function computeNbVisibleAvatar() {
    slider =  $document[0].querySelector('.gc-slider');
    if (!slider) return;

    var isMobile = window.innerWidth < 500;
    var maxSliderWidth = window.innerWidth - 25; // force slider not to be wider than page
    var sliderContainerWidth = Math.min(slider.getBoundingClientRect().width, maxSliderWidth);
    var sliderWidth = sliderContainerWidth - (isMobile ? 22 : 32) * 2 - (isMobile ? 125 : 145);
    var sliderItem = slider.querySelector('.gc-slider-item');
    service.avatarWidth = sliderItem && sliderItem.getBoundingClientRect().width || 32;
    service.maxVisibleAvatar = Math.floor(sliderWidth / service.avatarWidth);

    // maximum 20 visible avatars, because /thread never returns more than 20 child comments
    service.maxVisibleAvatar = Math.min(service.maxVisibleAvatar, 20);

    if (isNaN(service.maxVisibleAvatar)) {
      throw `[GcError] maxVisibleAvatar is Nan: ${slider.getBoundingClientRect().width} ${service.avatarWidth}`;
    }
  }

  function onResize() {
    $timeout(function () {
      computeNbVisibleAvatar();
    }, 100, true);
  }
}]);
